// Трек платформы: линия пути и решение «сплошная или пунктир».
//
// РЕДКИЕ ФИКСЫ — ЭТО ПУНКТИР. Между всплытиями Argo (раз в десять суток) мы НЕ
// ЗНАЕМ, где он был; сплошная линия утверждала бы путь, которого никто не
// измерял. Пунктир идёт ПО САМИМ фиксам: вершины измерены, промежуток пуст.
// То же правило уже написано для разреженных треков судов
// (`tests/ais/test_sparse_track_segmentation.py`).

export interface TrackPoint {
  time: string | null
  lat: number
  lon: number
}

/** Медианный разрыв, начиная с которого линия рисуется пунктиром (часы). */
export const SPARSE_GAP_HOURS = 6

/** Долгота в непрерывной восточной шкале кадра.
 *
 *  Кадр карты может стоять за 180-м меридианом (`lonMin` больше 180). Знаковая
 *  долгота из базы уехала бы тогда на целый мир влево от кадра — тот же приём,
 *  что у выноски карточки (`anchorLng`) и укладки полей в решётку. */
export function toEast(lon: number, lonMin: number): number {
  return lon < lonMin ? lon + 360 : lon
}

function gapsHours(points: TrackPoint[]): number[] {
  const times = points
    .map(p => (p.time ? Date.parse(p.time) : NaN))
    .filter(t => Number.isFinite(t))
  const out: number[] = []
  for (let i = 1; i < times.length; i += 1) {
    out.push((times[i] - times[i - 1]) / 3_600_000)
  }
  return out
}

/** Разрежен ли трек: медиана разрывов больше порога. Медиана, а не среднее —
 *  один длинный перерыв в плотном ряду не делает весь трек разреженным. */
export function isSparseTrack(points: TrackPoint[]): boolean {
  const gaps = gapsHours(points)
  if (gaps.length === 0) return false
  const sorted = [...gaps].sort((a, b) => a - b)
  const mid = Math.floor(sorted.length / 2)
  const median = sorted.length % 2 ? sorted[mid] : (sorted[mid - 1] + sorted[mid]) / 2
  return median > SPARSE_GAP_HOURS
}

/** Линия трека в восточной шкале кадра; null — рисовать нечего.
 *
 *  Одна точка линией не является: это было бы утверждение о движении, которого
 *  мы не наблюдали. */
export function trackLine(
  points: TrackPoint[],
  lonMin = -180,
): GeoJSON.Feature<GeoJSON.LineString> | null {
  if (points.length < 2) return null
  return {
    type: 'Feature',
    properties: { sparse: isSparseTrack(points) },
    geometry: {
      type: 'LineString',
      coordinates: points.map(p => [toEast(p.lon, lonMin), p.lat]),
    },
  }
}
